import { Card, Icon, Pagination, CircularProgress, Box } from "@mui/material";
import { UserContext } from "App";
import UsersApi from "Classes/API/UsersApi";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { useContext, useEffect, useState } from "react";
import DateTimePicker from "react-datetime-picker/dist/DateTimePicker";
import { useNavigate } from "react-router-dom";
import AsyncSelect from "react-select/async";
import Swal from "sweetalert2";
import SearchPatientsReq from "./SearchPatientsReq";
import QuickDate from "../../components/QuickDate";
import searchUsersReq from "../../Classes/Models/Requests/Users/SearchUser";
import { LanguageContext } from "App";
import "./PatientFiles.scss";
import "./patientstyle.scss";
import translations from "layouts/Appointments/Feedback/translations";
import Loader from "Loader";
import { use } from "react";
const PatientList = () => {
  const navigate = useNavigate();
  const User = useContext(UserContext);
  const { translations, switchLanguage } = useContext(LanguageContext);
  const [patients, setPatients] = useState([]);
  const [Page, setPage] = useState(1);
  const [PaginationPages, setPaginationPages] = useState(0);
  const [FromDate, setFromDate] = useState(undefined);
  const [ToDate, setToDate] = useState(undefined);
  const [Name, setName] = useState("");
  const [Mobile, setMobile] = useState("");
  const [AddSectionVisible, setAddSectionVisible] = useState(false);
  const [Notes, setNotes] = useState("");
  const [PatientId, setPatientId] = useState(0);
  const [PatientSearch, setPatientSearch] = useState("");
  const [Patient, setPatient] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasEntries, setHasEntries] = useState(false);

  const [OptionPatients, setOptionPatients] = useState([]);

  useEffect(() => {
    GetPatients().then((res) => {
      setOptionPatients(res);
    });
  }, []);

  useEffect(() => {
    fetchPatients();
  }, [Page]);

  useEffect(() => {
    console.log(Patient);
  }, [Patient]);

  const GetPatients = async (inputValue) => {
    let searchReq = new searchUsersReq();
    searchReq.userType = "Patient";
    searchReq.name = inputValue || "";

    let res = await UsersApi.SearchUsers(searchReq);

    if (res.status === "Success") {
      return res.data.list.map((item) => ({
        value: item,
        label: item.name,
      }));
    }

    return [];
  };

  const [TableDataRows, setTableDataRows] = useState([]);
  const RefreshTable = (resList) => {
    var rows = [];
    console.log(resList);
    resList.forEach((session, index) => {
      rows.push(MakeTableRow(session, index));
    });
    setTableDataRows(rows);
  };

  const getTableColumns = () => {
    const columns = [
      {
        Header: translations.FilterpatientsbyId,
        accessor: "Id",
        align: "left",
      },
      {
        Header: translations.FilterpatientsbyPatientName,
        accessor: "Name",
        align: "left",
      },
      {
        Header: translations.FilterpatientsbyPatientEmail,
        accessor: "Email",
        align: "left",
      },
      {
        Header: translations.FilterpatientsbyPatientHistoryEntries,
        accessor: "ShowEntries",
        align: "center",
      },
    ];

    if (User.userType !== "Therapist") {
      columns.splice(3, 0, {
        Header: translations.FilterpatientsbyPatientNumber,
        accessor: "Number",
        align: "left",
      });
    }
    return columns;
  };

  const MakeTableRow = (user, index) => {
    return {
      Id: (
        <MDTypography component="p" variant="button" color="dark">
          {user?.id}
        </MDTypography>
      ),
      Name: (
        <MDTypography component="p" variant="button" color="dark">
          {user?.name}
        </MDTypography>
      ),
      Email: (
        <MDTypography component="p" variant="button" color="dark">
          {user?.email}
        </MDTypography>
      ),
      Number: User.userType !== "Therapist" && (
        <MDTypography component="p" variant="button" color="dark">
          {user?.number}
        </MDTypography>
      ),
      ShowEntries: (
        <MDButton
          sx={{
            backgroundColor: "#3560AD",
            "&:hover": { backgroundColor: "#4682B4" },
          }}
          color="text"
          onClick={() => {
            console.log(user);
            navigate("/PatientHistory/" + user.getPatient.id, {
              state: { patient: user },
            });
          }}
        >
          {translations.FilterpatientsbyShowEntries}
        </MDButton>
      ),
    };
  };
  // const fetchPatients = async () => {
  //     try {
  //         let req = new SearchPatientsReq();
  //         if (User.userType == "Therapist") {
  //             req.therapistId = User.therapistId != null ? User.therapistId : User.getTherapist?.id;;
  //             req.pagingParams.pageNumber = Page;
  //             req.pagingParams.pageSize = 10;
  //             req.FromDate = FromDate;
  //             req.ToDate = ToDate;
  //             req.Name = Name;
  //             req.Mobile = Mobile;
  //             req.Id = Patient?.id;

  //             console.log(req)

  //             UsersApi.GetPatientsOfTherapist(req).then((res) => {

  //                 RefreshTable(res.data.list)
  //                 setPatients(res.data.list);
  //                 setPaginationPages(res.data.totalPages)
  //             });
  //         }
  //         else if (["Admin", "Owner", "HeadAccounting"].includes(User.userType) || User.userType == "SuperAdmin" || User.userType == "AppointmentEmployee" || User.userType == "AccountingEmployee") {
  //             req.therapistId = null;
  //             req.pagingParams.pageNumber = Page;
  //             req.pagingParams.pageSize = 10;
  //             req.FromDate = FromDate;
  //             req.ToDate = ToDate;
  //             req.Name = Name;
  //             req.Mobile = Mobile;
  //             req.Id = Patient?.id;

  //             console.log(req)
  //             UsersApi.GetPatientsOfTherapist(req).then((res) => {

  //                 RefreshTable(res.data.list)
  //                 setPatients(res.data.list);
  //                 setPaginationPages(res.data.totalPages)
  //             });
  //         }
  //         else {
  //             Swal.fire({
  //                 title: 'Error',
  //                 text: 'You are not therapist',
  //                 icon: 'error',
  //                 confirmButtonText: 'OK'
  //             })
  //         }
  //     } catch (error) {
  //         console.error('Error fetching patient data:', error);
  //     }
  // };

  const fetchPatients = async () => {
    try {
      let req = new SearchPatientsReq();
      req.therapistId = null;
      req.pagingParams.pageNumber = Page;
      req.pagingParams.pageSize = 10;
      req.FromDate = FromDate;
      req.ToDate = ToDate;
      req.Name = Name;
      req.Number = Mobile;
      req.Id = Patient?.id;
      req.hasEnteries = hasEntries;

      if (FromDate) {
        req.FromDate = FromDate + "T00:00:00";
      }

      if (ToDate) {
        req.ToDate = ToDate + "T23:59:59";
      }

      console.log("req", req);
      const res = await UsersApi.GetPatientsOfTherapist(req);

      RefreshTable(res.data.list);
      setPatients(res.data.list);
      setPaginationPages(res.data.totalPages);
    } catch (error) {
      console.error("Error fetching patient data:", error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card
        mb={3}
        id="SearchUsers"
        className={translations.setlang === "ar" ? "rtl-label" : ""}
      >
        <MDBox
          pt={2}
          px={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MDTypography variant="h6" fontWeight="medium">
            {translations.Filterpatientsby}
          </MDTypography>
        </MDBox>

        <div className="card-info-container">
          <span>
            <MDInput
              styles={{ width: "80%" }}
              type={"tel"}
              className="full-width"
              onChange={(e) => setMobile(e.target.value)}
              label={translations.FilterpatientsbyMobilenumber}
              InputLabelProps={{ style: { fontSize: "18px" } }}
              inputProps={{ style: { fontSize: "18px" } }}
              fullWidth
            ></MDInput>
          </span>
          <div className="input-serch">
            <AsyncSelect
              isClearable={true}
              placeholder={translations.FilterpatientsbySelectbypatientname}
              loadOptions={GetPatients}
              defaultOptions={OptionPatients}
              onInputChange={(value) => setPatientSearch(value)}
              onChange={(e) => setPatient(e ? e.value : "")}
              styles={{
                control: (provided) => ({
                  ...provided,
                  height: "44px",
                  borderRadius: "5px",
                }),
                valueContainer: (provided) => ({ ...provided, height: "100%" }),
                placeholder: (provided) => ({
                  ...provided,
                  fontSize: "18px",
                  opacity: 0.8,
                }),
              }}
            />
          </div>

          <div className="qd">
            <div className="quick_date_container">
              <p>{translations.PatientStayQuickDate}</p>
              <QuickDate
                setFrom={setFromDate}
                setTo={setToDate}
                placeholder={"Quick Last Updated"}
              />
            </div>
          </div>
          <div className="qd">
            <label>{translations.PatientStayStartDateFrom}:</label>
            <div
              className="quick_date"
              style={{
                display: "grid",
                gridTemplateColumns: "auto auto auto", // 3 columns for the input, p, and second input
                gap: "10px", // optional, for spacing between the columns
                alignItems: "center", // vertically center the items
              }}
            >
              <input
                type="date"
                style={{
                  width: "auto",
                  ...(window.innerWidth <= 768 && { width: "100%" }),
                }}
                onChange={(e) => {
                  setFromDate(e.target.value);
                }}
                value={FromDate}
              />

              <p>{translations.PatientStayTo}</p>

              <input
                type="date"
                style={{
                  width: "auto",
                  ...(window.innerWidth <= 768 && { width: "100%" }),
                }}
                onChange={(e) => {
                  setToDate(e.target.value);
                }}
                value={ToDate}
              />
            </div>
          </div>
        </div>

        {/* check box */}
        <MDBox
          pt={2}
          px={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          margin="20px"
          marginRight="5%"
          sx={{
            "@media (max-width: 767px)": {
              justifyContent: "center",
              marginTop: "0px",
            },
          }}
        >
          <div>
            <input
              className="input-checkbox"
              type="checkbox"
              id="includeInactive"
              checked={hasEntries}
              onChange={(e) => setHasEntries(e.target.checked)}
            />
            <label className="label-checkbox" for="includeInactive">
              Show Patients With Entries Only
            </label>
          </div>

          <MDButton
            onClick={() => fetchPatients()}
            sx={{
              backgroundColor: "#3560AD",
              "&:hover": { backgroundColor: "#4682B4" },
            }}
            color="info"
          >
            <Icon sx={{ fontWeight: "bold" }}>search</Icon>
            &nbsp;{translations.FilterpatientsbySearchpatients}
          </MDButton>
        </MDBox>
      </Card>
      {loading ? (
        <Loader />
      ) : (
        <Card className="mt-5">
          <MDBox
            mt={-3}
            py={3}
            px={2}
            bgColor="#3560AD"
            coloredShadow="info"
            textAlign="center"
            backgroundColor="#3560AD"
            sx={{
              borderTopLeftRadius: "1.1rem",
              borderTopRightRadius: "1.1rem",
            }}
          >
            <MDTypography variant="h6" color="white">
              {translations.Filterpatientsby}
            </MDTypography>
          </MDBox>

          <MDBox pt={3} position="relative">
            <DataTable
              table={{ columns: getTableColumns(), rows: TableDataRows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
            />
            <div className="text-right mx-3 my-4">
              <Pagination
                count={PaginationPages}
                color="primary"
                onChange={(e, number) => setPage(number)}
                className="float-right"
              />
            </div>
          </MDBox>
        </Card>
      )}
    </DashboardLayout>
  );
};

export default PatientList;
